import { ContentfulSupportLandingPage } from '@jbhi-fi/apis/src/contentful/types';
import { HelpAndSupportLandingProps } from '../../HelpAndSupport/HelpAndSupportLanding/HelpAndSupportLanding';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import React from 'react';
import { MultiColumnBlockTransformer } from './MultiColumnBlockTransformer';

export abstract class SupportLandingPageTransformer {
  static toHelpAndSupportLandingPageProps = (entry: ContentfulSupportLandingPage): HelpAndSupportLandingProps => {
    return {
      categories:
        entry?.fields?.supportCategories?.map(category => ({
          title: category?.fields?.heading || '',
          icon: category.fields?.icon ? <Icon name={category.fields?.icon} /> : undefined,
          url: category?.fields?.urlSlug || '',
        })) || [],
      suggestedArticles: [],
      supportSections: entry.fields?.supportSections?.map(MultiColumnBlockTransformer.toMultiColumnBlockProps) || [],
    };
  };
}
